import type { Middleware } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { DoorState, TransactionState } from "../../types";
import { selectDoorOpenedDuringTransactionId, selectDoorState, setDoorOpenedDuringTransactionId } from "../doorSlice";
import { selectActiveLocalTransaction } from "../transactionSlice";

/**
 * Keeps "the door opened during this transaction" in step with the store after every action, so it
 * holds whichever path changed the door or the slot (frames, the initial state, the debug tools) and
 * whether a flow is mounted yet. The door counts while an ACTIVE order or local refill holds the slot,
 * as the RFID step machine counted it; the record goes when the slot empties.
 */
export const doorOpenedMiddleware: Middleware = (store) => (next) => (action) => {
	const result = next(action);
	const state = store.getState() as RootState;
	const transaction = selectActiveLocalTransaction(state);
	const openedDuring = selectDoorOpenedDuringTransactionId(state);
	if (transaction === null) {
		if (openedDuring !== null) {
			store.dispatch(setDoorOpenedDuringTransactionId(null));
		}
	} else if (
		selectDoorState(state) === DoorState.Opened &&
		transaction.state === TransactionState.Active &&
		openedDuring !== transaction.id
	) {
		store.dispatch(setDoorOpenedDuringTransactionId(transaction.id));
	}
	return result;
};
